import axios from "axios";
const { REACT_APP_API_URI } = process.env;

const client = axios.create({
  baseURL: REACT_APP_API_URI,
});

export default client;
